import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { login } from "../services/api"

export default function LoginPage() {
  const [username, setUsername] = useState("")
  const [password, setPassword] = useState("")
  const [error, setError] = useState("")
  const navigate = useNavigate()

  const handleLogin = async (e) => {
    e.preventDefault()
    try {
      const res = await login(username, password)
      localStorage.setItem("user", JSON.stringify(res.data))
      navigate("/editor")
    } catch {
      setError("Credenciales inválidas")
    }
  }

  return (
    <div className="h-screen flex items-center justify-center bg-gray-100">
      <form onSubmit={handleLogin} className="bg-white p-8 shadow-lg rounded">
        <h2 className="text-xl mb-4">Iniciar sesión</h2>
        <input className="w-full mb-2 p-2 border" placeholder="Usuario" onChange={e => setUsername(e.target.value)} />
        <input className="w-full mb-4 p-2 border" type="password" placeholder="Contraseña" onChange={e => setPassword(e.target.value)} />
        {error && <div className="text-red-500 mb-2">{error}</div>}
        <button className="bg-blue-500 text-white px-4 py-2 w-full" type="submit">Entrar</button>
      </form>
    </div>
  )
}
